module.exports = __webpack_public_path__ + "img/loginImage.7f43249d.png";